import React, { createContext, useEffect, useMemo, useState } from 'react';
import jwtDecode, { JwtPayload } from "jwt-decode";
import { Moment } from 'utils/helpers/date_helpers';

export interface JwtPayloadExt extends JwtPayload {
  user?: any;
  appDomain?: string;
}

type AuthProps = {
  isAuthenticated: boolean;
  currentUser: any,
  authenticate: Function;
  signout: Function;
  refreshProfile: Function;
  appDomain: string;
};

export const AuthContext = createContext({} as AuthProps);

const AuthProvider = (props: any) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [currentUser, setCurrentUser] = useState<any>(null);
  const [appDomain, setAppDomain] = useState<any>(null);

  useEffect(() => {
    validateToken();
  }, []);

  const validateToken = async () => {
    try {
      const token = await localStorage.getItem('token')

      // JWT decode & check token validity & expiration.
      if (token) {
        const decodedToken = jwtDecode<JwtPayloadExt>(token)
        const expDate = Moment(decodedToken.exp, 'X');

        if (decodedToken && (Moment() < expDate)) {
          setIsAuthenticated(true)
          setCurrentUser(decodedToken?.user)
          setAppDomain(decodedToken?.appDomain)
        } else {
          signout(() => { console.log('Session expired') })
        }
        // else {
        //   CommonActions.navigate("Home")
        // }
      }
    } catch (e) {
      return false;
    }
  };

  const authenticate = async ({ token }: { token: string }, cb: any) => {
    try {
      //const verifiedToken = jwt.verify(token, 'condominio505');
      const decodedToken = jwtDecode<JwtPayloadExt>(token)

      if (decodedToken) {
        const user = decodedToken?.user;
        await localStorage.setItem('token', token)
        setIsAuthenticated(true);
        setCurrentUser(user);
        setAppDomain(decodedToken?.appDomain)
      }
    } catch (e) {
      console.log('Err.', e)
    }
    setTimeout(cb, 100); // fake async
  }

  const refreshProfile = async (profile: any) => {
    currentUser.profile = profile;
    setCurrentUser(currentUser);
  }

  const signout = async (cb: any) => {
    await localStorage.removeItem('token')
    setIsAuthenticated(false);
    setCurrentUser(null);
    setAppDomain(null);
    setTimeout(cb, 100);
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        currentUser,
        appDomain,
        authenticate,
        refreshProfile,
        signout
      }}
    >
      <>{props.children}</>
    </AuthContext.Provider>
  );
};

export default AuthProvider;
